"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a request returns BadRequestError because the class has reached the maximum number of teachers
 * @param {string} classId the class to which a teacher was being added
 */
class ClassTeacherLimitExceeded extends client_library_1.ExtendableError {
    constructor(classId) {
        super(`class: ${classId} has reached the maximum number of teachers`);
    }
}
exports.default = ClassTeacherLimitExceeded;
//# sourceMappingURL=ClassTeacherLimitExceeded.js.map